export default __webpack_public_path__ + "static/media/no-thumbnail.b44e5c13.png";